"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applicationWrapperSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const walletApplicationWrapperInterfaces_1 = require("../walletApplicationWrapperInterfaces");
const defaultWalletApplicationWrapperstate = Object.assign({}, walletApplicationWrapperInterfaces_1.defaultWalletApplicationWrapper);
exports.applicationWrapperSlice = (0, toolkit_1.createSlice)({
    name: "applicationWrapper",
    initialState: defaultWalletApplicationWrapperstate,
    reducers: {
        walletApplicationDefaultsLoaded: (state, action) => {
            state.groupInfo = action.payload.groupInfo;
            state.supportedCurrencies = action.payload.supportedCurrencies;
            state.tokenList = action.payload.tokenList;
            state.supportedNetworks = action.payload.supportedNetworks;
            state.filteredAssets = action.payload.filteredAssets;
            state.currencyPairs = action.payload.currencyPairs;
            state.walletWrapperInitialized = true;
        },
        walletApplicationUser: (state, action) => {
            // console.log(action.payload);
            state.userProfile = action.payload.userProfile;
            state.authToken = action.payload.authToken;
        },
        resetWalletApplicationUser: (state) => {
            state.userProfile = walletApplicationWrapperInterfaces_1.defaultWalletApplicationWrapper.userProfile;
            state.authToken = walletApplicationWrapperInterfaces_1.defaultWalletApplicationWrapper.authToken;
        },
        swapToAndFromToken: (state, action) => {
            state.fromInfo = action.payload.fromInfo;
            state.toInfo = action.payload.toInfo;
        },
        updateToInfo: (state, action) => {
            state.toInfo = action.payload.toInfo;
        },
        updateFromInfo: (state, action) => {
            state.fromInfo = action.payload.fromInfo;
        },
        availableLiquidity: (state, action) => {
            state.availableLiquidity = action.payload.availableLiquidity;
        },
        updateAmount: (state, action) => {
            state.amount = action.payload.amount;
        },
        updateFee: (state, action) => {
            state.fee = action.payload.fee;
        },
        updateMaxBalance: (state, action) => {
            state.maxBalance = action.payload.maxBalance;
        },
        getNetworkTransactions: (state, action) => {
            state.networkTransactions = action.payload.networkTransactions;
        },
        httpProviders: (state, action) => {
            state.providers = action.payload.providers;
        },
    },
});
//# sourceMappingURL=walletApplicationWrapperSlice.js.map